export const ADMIN_ROLE_SLUG = 'admin'
export const OPERATIONS_DIRECTOR_ROLE_SLUG = 'operations_director'

export const OPERATIONS_DIRECTOR_DENIED_ROUTE_PREFIXES = [
  '/admin',
  '/system',
  '/cc',
  '/cards_issue_orders',
  '/cards_topup_orders',
  '/refunds',
] as const

export const OPERATIONS_DIRECTOR_DENIED_ROLE_SLUGS = [
  'admin_withdraw_balance',
  'admin_deposit_balance',
  'admin_energy_rental',
  'admin_withdraw_tron',
  'view_card_issue_requests',
  'view_card_topup_requests',
  'cancel_card_topup_orders',
] as const

export const isOperationsDirectorDeniedPath = (path: string): boolean => {
  return OPERATIONS_DIRECTOR_DENIED_ROUTE_PREFIXES.some((prefix) => path.startsWith(prefix))
}
